import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken, VISUALLY_HIDDEN } from '@optimus-web/common';

interface FormLabelProps {
    children: React.ReactNode;
    required?: boolean;
    inline?: boolean;
    as?: React.ElementType;
    onClick?: () => void;
    htmlFor?: string;
}

type FormLabelElementProps = Pick<FormLabelProps, 'inline'>;

export const FormLabelElement = styled.label<FormLabelElementProps>`
    ${getTextTokenPreset('BODY_M_STRONG')};
    color: ${getToken(TokenName.TEXT_STATIC_PRIMARY)};
    ${(props) => props.inline && VISUALLY_HIDDEN}
`;

export const Asterisk = styled.span`
    ${getTextTokenPreset('BODY_M_STRONG')};
    padding-left: ${getToken(TokenName.SPACING_50)}px;
    color: ${getToken(TokenName.TEXT_STATIC_PRIMARY)};
`;

export const FormLabel = ({ children, required, ...other }: FormLabelProps) => (
    <FormLabelElement {...other}>
        {children}
        {required ? <Asterisk aria-hidden>*</Asterisk> : null}
    </FormLabelElement>
);
